import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { Add } from '@carbon/react/icons';
import { Button } from '@carbon/react';
import { Helmet } from 'react-helmet-async';
import { PageHeader } from 'components/page-header';
import { pageTitle } from 'utils/page-title';
import routes from '~/routes';
import TaxScenariosContent from './tax-scenarios-content';

/**
 * Entry page for the Tax Scenario list.
 * @return {JSX.Element} The list page
 */
const TaxScenariosPage: FC = () => {
  const history = useHistory();

  return (
    <>
      <Helmet>
        <title>{pageTitle('Tax Scenarios')}</title>
      </Helmet>
      <PageHeader
        breadcrumbs={[]}
        title="Tax Scenarios"
        actions={
          <Button
            renderIcon={Add}
            kind="primary"
            onClick={() => history.push(routes.newTaxScenarioPath)}
          >
            Create Tax Scenario
          </Button>
        }
      />
      <TaxScenariosContent />
    </>
  );
};

export { TaxScenariosPage };
